import {
  SeButton,
  SeDialog,
  SeDialogContent,
  SeDialogFooter,
  SeDialogHeader,
  SeDivider,
} from "@se/web-ui-react";
import React from "react";
const IOConfig = ({ showConfig, onClose, documentList }) => (
  <SeDialog id="dialog-simple-notitle" size="xlarge" open={showConfig}>
    <SeDialogHeader color="primary">EMO-M Controller I/O </SeDialogHeader>
    <SeDialogContent>
      {Object.entries(documentList).length > 0 ? (
        Object.entries(documentList).map(([reference, tables], entIndex) =>
          Object.entries(tables).map(([tableNumber, rows], index) => {
            const inputCount = rows.filter((item) =>
              item.input.startsWith("I")
            ).length;
            const outputCount = rows.filter((item) =>
              item.input.startsWith("Q")
            ).length;
            return (
              <div
                key={`${reference}-${index}`}
                style={{ marginInline: "5%", marginTop: (entIndex !== 0 || index !== 0) ? "5%" : "0%" }}
              >
                <div>
                  <table
                    className="table  table-bordered
 "
                  >
                    <thead>
                      <tr>
                        <th colSpan={6}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>
                              EMO-M I/O Card Name:{" "}
                              <span className="bold">{reference} #{index+1}</span>
                            </span>
                            <span>
                              Status:{" "}
                              <span className="bold">
                                I/O Card utilized, must be connected
                              </span>
                            </span>
                            <span>
                              Type:
                              <span className="bold">
                                {" "}
                                Inputs {inputCount} / {outputCount} Outputs
                              </span>
                            </span>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th className="border-right" width="3%"></th>
                        <th className="border-right" scope="col" width="10%">
                          Input/Output
                        </th>
                        <th className="border-right" scope="col" width="20%">
                          Sub System Definition
                        </th>
                        <th className="border-right" scope="col" width="20%">
                          Signal Definition
                        </th>
                        <th className="border-right" scope="col" width="20%">
                          Details
                        </th>
                       
                      </tr>
                    </thead>
                  </table>
                </div>
                <div
                  style={{
                    overflowX: "auto",
                    maxHeight: "400px",
                    scrollbarWidth: "none",
                    marginTop: "-18px",
                    // marginBottom: "5%",
                  }}
                >
                  <table
                    className="table table-bordered mb-0"
                    style={{ tableLayout: "fixed" }}
                  >
                    <tbody>
                      {rows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {rowIndex === 0  && (
                            <td
                              width={"3%"}
                              rowSpan="16"
                              style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                                writingMode: "tb-rl",
                                transform: "rotate(180deg)",
                              }}
                            >
                           {inputCount > 0?"Inputs":"Outputs"}
                            </td>
                          )}
                          {rowIndex === 16 && (
                            <td
                              width={"3%"}
                              rowSpan="8"
                              style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                                writingMode: "tb-rl",
                                transform: "rotate(180deg)",
                              }}
                            >
                              Outputs
                            </td>
                          )}
                          <td width="10%">{row.input}</td>
                          <td width="20%">{row.subSystemDef}</td>
                          <td width="20%">{row.signalDef}</td>
                          <td width="20%">{row.details}</td>
                         
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <SeDivider />
                  <SeDivider />
                </div>
                <SeDivider />
              </div>
            );
          })
        )
      ) : (
        <h3>No Data Found</h3>
      )}
    </SeDialogContent>
    <SeDialogFooter>
      <SeButton onClick={onClose}>Cancel</SeButton>
    </SeDialogFooter>
  </SeDialog>
);
export default IOConfig;
